import { Analytics } from '@cobliteam/analytics';
import { useTranslation } from '@cobliteam/i18n';
import { Switch } from '@cobliteam/ui/components';
import { FormControl, FormField, FormItem, FormLabel, useFormContext } from '@cobliteam/ui/form';

import type { FormValues } from '../../checklistSchema';

interface ChecklistItemRequiredProps {
  index: number;
}

const ChecklistItemRequired = ({ index }: ChecklistItemRequiredProps) => {
  const { t } = useTranslation('checklists');
  const { control, setValue } = useFormContext<FormValues>();

  return (
    <FormField control={control} name={`items.${index}.required`}>
      {({ field }) => (
        <FormItem className='flex items-center gap-2.5'>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={(checked) => {
                Analytics.track('Checklist Item Required Changed', {
                  required: checked,
                });

                // Business logic: user can't require photos if the question is not required
                if (!checked) {
                  setValue(`items.${index}.shouldRequestPhotos`, false);
                }
                field.onChange(checked);
              }}
            />
          </FormControl>
          <FormLabel>{t('required_question')}</FormLabel>
        </FormItem>
      )}
    </FormField>
  );
};

export default ChecklistItemRequired;
